<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
           
            <div v-if="request.length > 0">
              <h4
                style="color: #000; text-align: left"
                class="custom-user-grade"
              >
              Select from the list to become a partner
              </h4>
              <br />

              <div class="list-grade">
                <CCol>
                  <CRow class="">
                    <CCol class="ml-2">
                      <CRow class="mb-3">
                        <CCol sm="3"><strong>Student</strong></CCol>
                        <CCol sm="3"><strong>Tutor</strong></CCol>
                        <CCol sm="3"><strong>Wait Untill</strong></CCol>
                        <CCol sm="3"></CCol>

                      </CRow>
                      <div style="clear: both"></div>
                  <hr />
                      <CRow v-for="item in request"
                  v-bind:key="item.Id"
                  sm="12"
                  class=""
                >
                       
                        <CCol sm="3">
                          <p
                            class=""
                            style="
                              font-weight: 600;
                              color: #000a2c;
                              margin-bottom: 5px;
                            "
                          >
                            {{ item.StudentName }}
                          </p>
                          <p class="form" style="margin-bottom: 0px">
                            {{ item.Subject }}
                          </p>
                          <p class="form" style="margin-bottom: 0px">
                            {{ item.Grade }}
                          </p>
                        </CCol>
                        <CCol sm="3">
                          <div class="d-md-none"><br /></div>
                          <p
                            class=""
                            style="
                              font-weight: 600;
                              color: #000a2c;
                              margin-bottom: 5px;
                            "
                          >
                            {{ item.Teacher }}
                            <br />
                            <CButton
                            type="button"
                            color="link" square
                            @click="OpenResume(item)"
                            >View Profile</CButton
                          >
                          </p>
                          <!-- <p class="text-left">
                            <CButton
                            type="button"
                            color="link" square
                            @click="OpenResume(index, item.TeacherUserId)"
                            >View Profile Tutor</CButton
                          >
                          </p> -->
                        
                         

                        </CCol>
                        <CCol sm="3">
                          <div class="d-md-none"><br /></div>
                          <p
                            class=""
                            style="
                              font-weight: 600;
                              color: #000a2c;
                              margin-bottom: 5px;
                            "
                          >
                            Waiting untill
                            {{ item.ExpiredDate | moment("DD/MM/YYYY") }}
                          </p>
                          <p class="form" style="margin-bottom: 0px">
                            {{ item.Language }}
                          </p>
                        </CCol>
                        <CCol sm="3">
                          <CButton
                            type="button"
                            color="success"
                            class="mt-3"
                            @click="
                              GoToSelectStudent(
                                item.Id,
                                item.FindTutorId,
                                item.StartTime
                              )
                            "
                            >Select</CButton
                          >

                         

                        </CCol>
                        <CCol sm="12">
                      <div v-if="selectedRow === item.Id && showresume">
                        <CCard class="mt-2">
                  <div style="margin: 0px 20px">
                    <h5 class="mt-2"><strong>Resume Tutor</strong></h5>
                    <br />
                    <CRow>
                      <CCol sm="12">
                        <CRow>
                          <CCol sm="2">
                            <img
                              :src="photoURLteacher"
                              width="50px"
                              height="50px"
                              style="border-radius: 30px"
                            />
                          </CCol>
                          <CCol sm="10">
                            <h5>
                             <strong>{{ tutorProfile.name }}</strong> 
                            </h5>
                            <!-- <h6 class="text-blue">
                              {{ tutorProfile.email }}
                            </h6> -->
                            <h6>
                              <div
                                v-for="item in tutorProfile.academicProfileList"
                                :key="item.Id"
                                :index="item.Id"
                              >
                               <i>
                                {{ item.name }}
                               </i> 
                              </div>
                            </h6>
                          </CCol>
                          <hr />
                        </CRow>
                      </CCol>
                    </CRow>
                    <br />
                    <h5 class="mt-3"><strong>Teaching Subject</strong></h5>
                    <br />
                    <span
                      v-for="item in tutorProfile.teachingSubjectList"
                      :key="item.Id"
                      :index="item.Id"
                    >
                     <CBadge color="success" class="m-1"> {{ item.subjectName }} - {{  item.gradeName }}</CBadge>
                </span>

                    <br />
                    <h5 class="mt-3"><strong>Academic Level</strong></h5>
                    <br />
                    <div
                      v-for="item in tutorProfile.academicLevels"
                      :key="item.Id"
                      :index="item.Id"
                    >
                      <ul>
                        <li>
                          {{ item.instituteName }}
                          <br />
                          <i class="small text-muted">{{
                            item.academicLevelName
                          }}</i>
                        </li>
                      </ul>
                    </div>
                    <h5 class="mt-3"><strong>Area of Expertise List</strong></h5>
                    <br />
                    <div
                      v-for="item in tutorProfile.areaOfExpertiseList"
                      :key="item.Id"
                      :index="item.Id"
                    >
                      <ul>
                        <li>{{ item.name }}
                        </li>
                      </ul>
                    </div>

                     <h5 class="mt-3"><strong>Work Background</strong></h5>
                    <br />
                    <div
                      v-for="item in tutorProfile.workBackgroundList"
                      :key="item.Id"
                      :index="item.Id"
                    >
                      <ul>
                        <li>{{ item.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </CCard>
                    </div>
                    </CCol>
                      </CRow>
                    </CCol>
                   
                  
                  </CRow>
              
                </CCol>
              </div>
            </div>

            <div v-else>
              <div class="text-center">
              
                <img src="../../assets/img/icon/no-student.svg" />
                <h3
                  style="
                    text-align: left;
                    margin: 20px 30px;
                    font-weight: 400px;
                    color: #000;
                    font-size: 12px;
                  "
                  class="sub-title-header text-center"
                >
                  We noticed that there is no waiting list....
                </h3>

              </div>
            </div>
          </div>
        </div>
      </div>
      <MainlayoutBottom></MainlayoutBottom>
    </CContainer>

    <div style="clear: both"></div>
    <div class="header-top">List to become a partner</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
      <br />
      
    </div>
    <div class="header-right">
      <span @click="GoHomePage()"><CIcon name="cil-home"/></span>
      <br />
      
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import MainlayoutBottom from "../../containers/TheBottomCustom.vue";

import moment from "moment";
Vue.use(require("vue-moment"));

Vue.use(VuejsDialog);

export default {
  components: {
    MainlayoutBottom,
  },
  data() {
    return {
      user: {},
      request: [],
      showresume: false,
      selectedRow: null,
      tutorProfile: {},
      photoURLteacher: "",
      //StudentId: this
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
      this.GetRequestWaiting();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetRequestWaiting(this.user.countryId);
          }
        });
    },

    async GetRequestWaiting() {

      if(this.user.countryId > 0 && this.user.countryId != 13)
      {
        this.$API
        .get(this.$GetListRequestWaitingByCountryId + "?countryId=" + this.user.countryId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.request = response.data;
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
      }
      else
      {
        this.$API
        .get(this.$GetListRequestWaiting, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.request = response.data;
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });

      }
      
    },

    UpdateGrade: function () {
      const formData = new FormData();
      formData.append("studentId", this.studentId);
      formData.append("grade", this.Grade.gradeName);

      return this.$API
        .post(this.$UpdateStudentGradeStatus, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;
            this.$dialog.alert("Successfully Update").then(function () {});
            this.GoToRefresh();
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    GoToRefresh() {
      window.location.reload();
    },

    GoToSubject(studentId, gradeId) {
      if (gradeId == 0) {
        this.studentId = studentId;
        this.PopupUpdateGrade = true;
      } else {
        this.$router.push(
          "/FindTutor/FTSubjectGroup?studentId=" +
            studentId +
            "&gradeId=" +
            gradeId
        );
      }
    },

    GoToRegisterStudent() {
      this.$router.push("/RegisterStudent");
    },

    GoBack() {
      this.$router.back();
    },
    GoHomePage() {
      this.$router.push("FTClassType");
    },

    GoToSelectStudent(Id, FindTutorId, StartTime) {
      this.$router.push(
        "FTChooseStudent?requestId=" +
          Id +
          "&FindtutorId=" +
          FindTutorId +
          "&StartTime=" +
          StartTime
      );
    },
    OpenResume(item) {
    this.showresume = !this.showresume;
    this.selectedRow = item.Id;
    this.teacher = item.TeacherUserId;

    this.$API
        .get(this.$ProfileTeacher + "?userId=" + this.teacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.tutorProfile = response.data;
            this.photoURLteacher = this.tutorProfile.picturePath
          }
        });
  },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input[type="text"] {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}
input[type="checkbox"] {
  opacity: 0;
}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: 100vh;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}

.form {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  /* identical to box height */

  /* #000A2C */

  color: #000a2c;
}
</style>